import { DocumentAPI } from '../../../types/salesforce/api/document/document-api';
import { DocumentDTO } from '../../../types/salesforce/dto/application/document-dto';

export function getDocumentDTOFromDocumentAPI(documentAPI: DocumentAPI): DocumentDTO {
  return {
    document_name: documentAPI.documentName,
    document_type: documentAPI.documentType,
    document_body: documentAPI.documentBody,
    id_number: documentAPI.idNumber,
  } as DocumentDTO;
}
